import { Controller } from '@hotwired/stimulus';
import WebauthnAuthentication from '../../api_client/webauthn_authentication'

export default class extends Controller {
  click(e) {
    e.preventDefault();
    new WebauthnAuthentication().challenge();
  }
}
